import { render } from "./standard.vue?vue&type=template&id=26990897&scoped=true"
import script from "./standard.vue?vue&type=script&lang=js"
export * from "./standard.vue?vue&type=script&lang=js"

import "./standard.vue?vue&type=style&index=0&id=26990897&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26990897"

export default script